import { render } from "./TimesheetInputDetails.vue?vue&type=template&id=0b510d3e&scoped=true"
import script from "./TimesheetInputDetails.vue?vue&type=script&lang=js"
export * from "./TimesheetInputDetails.vue?vue&type=script&lang=js"

import "./TimesheetInputDetails.vue?vue&type=style&index=0&id=0b510d3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b510d3e"]])

export default __exports__